import { defineStore } from "pinia";
import { identityManagerApi } from "@/services/infra/client-apis/identity-manager-api/identity-manager-api";
import type { SettingsGetResponse, SettingsKeyEnum } from "@/swagger-models/identity-manager-client";

export const useSecuritySettingsStore = defineStore("security-settings", {
  state: () => ({
    settings: null as SettingsGetResponse | null,
  }),

  actions: {
    async getSettings(): Promise<SettingsGetResponse | null> {
      try {
        const response = await identityManagerApi.settingsApi.getSecuritySettings();
        this.settings = response.data;
        return this.settings;
      } catch (error) {
        console.error("Failed to get security settings", error);
        throw error;
      }
    },

    async getSettingByKey<T extends object = object>(key: SettingsKeyEnum): Promise<T | null> {
      if (this.settings?.[key as keyof typeof this.settings]) {
        return this.settings[key as keyof typeof this.settings] as T;
      }

      try {
        const response = await identityManagerApi.settingsApi.getSecuritySettingByKey(key);
        this.settings = {
          ...this.settings,
          [key]: response.data,
        } as SettingsGetResponse;

        return response.data as T;
      } catch (error) {
        console.error(`Failed to get security setting by key ${key}:`, error);
        throw error;
      }
    },

    async updateSetting(key: SettingsKeyEnum, value: object): Promise<void> {
      try {
        await identityManagerApi.settingsApi.updateSecuritySettingByKey(key, value);
        if (this.settings) {
          this.settings = {
            ...this.settings,
            [key]: value,
          };
        }
      } catch (error) {
        console.error(`Failed to update ${key} setting:`, error);
        throw error;
      }
    },
  },
});
